import { ReactNode, useEffect, useRef, useState } from "react";
import { Accordion, Tab as BootstrapTab, Tabs } from "react-bootstrap";
import { useSelector } from "react-redux";
import { AppState } from "../redux/types";
import { USER_TYPE } from "../utils/constants";

interface TabProps {
    key1: string | null;
    onSelect: (key: string | null) => void;
    userForm: ReactNode;
    memberForm: ReactNode;
    seniorDetail: ReactNode;
    featureChoices: ReactNode;
    orders: ReactNode;
}

const Tab = ({ key1, onSelect, userForm, memberForm, seniorDetail, featureChoices, orders }: TabProps) => {
    const user = useSelector((state: AppState) => state.user);
    const isPhoneUser = user.chosenService === "phone";

    const tab4Ref = useRef<HTMLDivElement>(null);
    const [tab4Width, setTab4Width] = useState(1000);

    useEffect(() => {
        if (tab4Ref.current) {
            setTab4Width(tab4Ref.current.clientWidth - 32);
        }
    }, [tab4Ref]);

    const isAppOnlyCustomer = user.role === "customer" && user.userType === USER_TYPE.appOnly;
    const isCustomer = user.role === "customer" && user.userType === USER_TYPE.normal;

    const tabTitle1 = user.role === "customer" ? "1 Omat tiedot" : "1 Omat yhteystiedot";


    return (
        <>
            {key1 && isAppOnlyCustomer && (
                <Tabs id="controlled-tab" activeKey={key1} onSelect={onSelect}>
                    <BootstrapTab eventKey="asiakas" title={tabTitle1}>
                        {userForm}
                    </BootstrapTab>
                    <BootstrapTab eventKey="seniori" title="2 Lisää seniori" disabled={user.isSenior}>
                        {seniorDetail}
                    </BootstrapTab>
                    <BootstrapTab eventKey="laheinen" title="3 Lisää läheiset">
                        {memberForm}
                    </BootstrapTab>
                    <BootstrapTab eventKey="tilaus" title="Yhteenveto">
                        {orders}
                    </BootstrapTab>
                </Tabs>
            )}

            {key1 && isCustomer && (
                <Tabs id="controlled-tab" activeKey={key1} onSelect={onSelect}>
                    <BootstrapTab eventKey="asiakas" title={tabTitle1}>
                        {userForm}
                    </BootstrapTab>
                    <BootstrapTab eventKey="seniori" title="2 Lisää seniori" disabled={user.isSenior}>
                        {seniorDetail}
                    </BootstrapTab>
                    <BootstrapTab eventKey="laheinen" title="3 Lisää läheiset">
                        {memberForm}
                    </BootstrapTab>
                    <BootstrapTab
                        eventKey="raatalointi"
                        style={{ flexShrink: "max-content" }}
                        title={
                            <div
                                ref={tab4Ref}
                                style={{
                                    display: "flex",
                                    flexWrap: "wrap",
                                    width: "100%",
                                    maxWidth: tab4Width,
                                }}
                            >
                                <div style={{ width: "100%" }}>4 Räätälöi {isPhoneUser ? "puhelimen" : "tabletin"} ominaisuudet halutessasi</div>
                                {key1 === "raatalointi" && (
                                    <Accordion style={{ paddingLeft: 22, width: "100%" }}>
                                        <Accordion.Toggle eventKey="0" as="span" onClick={(e) => e.stopPropagation()}>
                                            <small style={{ color: "#4e5180", textDecoration: "underline", cursor: "pointer" }}>Lue lisää</small>
                                        </Accordion.Toggle>
                                        <Accordion.Collapse eventKey="0" style={{ width: "inherit" }}>
                                            <small style={{ display: "block", marginTop: "4px", color: "#595764" }}>
                                                {!isPhoneUser
                                                    ? "Tabletin oletusasetuksina on suomi, videopuhelun automaattinen avautuminen (Helppo ja Huoleton) ja valitun palvelun suosituin sovellusvalikoima."
                                                    : "Puhelimen oletusasetuksina on suomi, videopuhelun avautuminen yhdellä klikillä painamalla vastaa/hylkää ja perussovellusvalikoima. "}
                                            </small>
                                        </Accordion.Collapse>
                                    </Accordion>
                                )}
                            </div>
                        }
                    >
                        {featureChoices}
                    </BootstrapTab>
                    <BootstrapTab eventKey="tilaus" title="Yhteenveto">
                        {orders}
                    </BootstrapTab>
                </Tabs>
            )}

            {user.role === "member" && memberForm}
            {user.role === "senior" && seniorDetail}
        </>
    );
};

export default Tab;
